import { VISUALIZER_MASK_RADIUS_SIZE_FACTOR } from '../constants';

type CanvasSetupResult = {
    maskRadius: number;
    movementAreaWidth: number;
    movementAreaHeight: number;
    maxMaskSizeIncrease: number;
    ctx: CanvasRenderingContext2D;
} | null;

// oxlint-disable-next-line max-lines-per-function
export const setupCanvasAndReturnContextAndSizeInfo = (
    canvas: HTMLCanvasElement | null,
    size?: 'xs',
): CanvasSetupResult => {
    if (!canvas) return null;

    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    const container = canvas.parentElement;
    if (!container) return null;

    // Get initial dimensions
    const { width, height } = container.getBoundingClientRect();

    // Calculate mask radius to fit within container
    const totalRadius = Math.min(width, height) / 2; // 175px for 350px container
    // When size is 'xs', don't apply the maskRadiusSizeFactor to make the circle extend to the edge
    const maskRadius = size === 'xs' ? totalRadius : totalRadius / (1 + VISUALIZER_MASK_RADIUS_SIZE_FACTOR);
    const maxMaskSizeIncrease = maskRadius * VISUALIZER_MASK_RADIUS_SIZE_FACTOR;

    // Calculate movement area using the factor as a multiplier
    const movementAreaWidth = Math.floor((maskRadius + maxMaskSizeIncrease) * 2.3);
    const movementAreaHeight = Math.floor((maskRadius + maxMaskSizeIncrease) * 2.3);

    // Center the canvas relative to container
    const offsetX = (width - movementAreaWidth) / 2;
    const offsetY = (height - movementAreaHeight) / 2;
    canvas.style.maxWidth = 'unset';
    canvas.style.position = 'absolute';
    canvas.style.left = `${offsetX}px`;
    canvas.style.top = `${offsetY}px`;

    // Set up canvas with correct size and DPR
    const dpr = window.devicePixelRatio || 1;
    canvas.width = movementAreaWidth * dpr;
    canvas.height = movementAreaHeight * dpr;
    canvas.style.width = `${movementAreaWidth}px`;
    canvas.style.height = `${movementAreaHeight}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    return { maskRadius, movementAreaWidth, movementAreaHeight, maxMaskSizeIncrease, ctx };
};
